// Provides the FormKit config globally so base input types (form, group, hidden,
// radio, date, file, …) are registered synchronously at app startup.
//
// With `formkit.autoImport: true`, FormKit otherwise tree-shakes inputs and loads
// the config lazily per page via an async <FormKitLazyProvider>. In production that
// async config chunk can fail/arrive late, which surfaces as: Unknown input type "form".
// Registering optionsSymbol globally makes every <FormKitLazyProvider> short-circuit to
// a synchronous passthrough, so `form` is always known. Components/helpers stay auto-imported.
import { plugin as formkitPlugin, defaultConfig } from '@formkit/vue'
import formkitConfig from '~/formkit.config'

export default defineNuxtPlugin((nuxtApp) => {
  const config = typeof formkitConfig === 'function' ? (formkitConfig as () => any)() : formkitConfig
  nuxtApp.vueApp.use(formkitPlugin, defaultConfig(config as any))
})
